var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletanddigitalpayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.48,
    y: 1.48,
    width: 13.04,
    height: 13.04,
    rx: 27.5,
    fill: "var(--icon-asset-bg-primary)",
    strokeWidth: 0.96
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.48,
    y: 1.48,
    width: 13.04,
    height: 13.04,
    rx: 27.5,
    stroke: "var(--icon-asset-bg-secondary)",
    strokeWidth: 0.96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1)  scale(0.9) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2002 3.75028H9.80006",
    stroke: "var(--icon-secondary)",
    strokeWidth: 0.89739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2002 5.30667H9.80006",
    stroke: "var(--icon-secondary)",
    strokeWidth: 0.89739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26496 3.75024C8.10706 3.75024 8.7898 4.49558 8.7898 5.41479C8.7898 6.33443 8.10706 6.81345 7.26496 6.81345H6.2002L8.82306 9.14272",
    stroke: "var(--icon-secondary)",
    strokeWidth: 0.89739,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 12.1428H10.4001",
    stroke: "var(--icon-primary)",
    strokeWidth: 0.96,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletanddigitalpayments);
export default __webpack_public_path__ + "static/media/wallet and digital payments.d5b2a92051fb5cc0e190072f0c37a5b2.svg";
export { ForwardRef as ReactComponent };